import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

export interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  variant?: "default" | "warning" | "critical" | "success";
}

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, variant = "default", ...props }, ref) => {
  const indicatorStyles = {
    default: "bg-gradient-to-r from-[hsl(243,75%,59%)] to-[hsl(239,84%,67%)]",
    success: "bg-gradient-to-r from-[hsl(142,71%,45%)] to-[hsl(142,76%,36%)]",
    warning: "bg-gradient-to-r from-[hsl(38,92%,50%)] to-[hsl(45,93%,47%)]",
    critical: "bg-gradient-to-r from-[hsl(0,84%,60%)] to-[hsl(0,72%,51%)]",
  };

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 transition-all",
          indicatorStyles[variant]
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
